import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import TableContainer from '@mui/material/TableContainer';
import FormControl from '@mui/material/FormControl';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useTranslation} from "react-i18next";
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Grid from '@mui/material/Grid';
import {observer} from 'mobx-react';
import React from 'react';
import {locListSort, locTypes, LOCT_CITY, LOCT_ASSO, LOCT_REG, LOCT_ADDR} from '../Locations.js';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {getCityName, getCountryName} from '../Trans.js';
import {TAB_LOCATION, TAB_LOC} from './StatsCommon.js';
import StatsFilter from './StatsFilter.js';
import StatsRow from './StatsRow.js';
import {COMM_OK} from '../WsR2.js';

const LocationSrc = (props) => {
	const {t} = useTranslation('obs');
	const {arr} = props;
	let prev_y = -1, i;
	let ret = [];

	if (!arr || !arr.length || !arr[0].spec_id)
		return null;

	let ol = arr.length;

	for (i = ol - 1; i >= 0 ; i--) {
		let obs = arr[i], bg;
		const y = new Date(obs.start_t * 1000.0).getYear();

		if (y !== prev_y) {
			let j, n;

			n = 1;

			for (j = i - 1; j >= 0; j--) {
				let obs2 = arr[j];
				const y2 = new Date(obs2.start_t * 1000.0).getYear();

				if (y2 !== y) 
					break;

				n++;
			}

			if (prev_y !== -1)
				ret.push(<TableRow key={-y * 2 - 1}><TableCell colSpan={4}>&nbsp;</TableCell></TableRow>);

			ret.push(<TableRow key={-y * 2} style={{backgroundColor: '#f0f0f0'}}><TableCell colSpan={4}>{(y + 1900) + ' ' + n + ' ' + t('stats.species')}</TableCell></TableRow>);
		}

		bg = obs.lifer ? '#cbffe2' : '#ffffff';

		ret.push(
			<StatsRow
				key	= {i + 1}
				bgcolor	= {bg}
				row_n	= {i + 1}
				obs	= {obs}
			/>);

		prev_y = y;
	}

	return ret;
}

export {LocationSrc};

const StatsLoc = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function statsLocGetCityName(id) {
		const city = gStorage.lists.citylist.list.find(elem => elem.id === id);
		const usr = gStorage.conn.user;

		// console.log('statsCityGetCityName', id, city);

		let a_str = '';

		if (city.country !== usr.def_country) {
			const country = gStorage.lists.countrylist.find(x => x.id === city.country);
			a_str = getCountryName(country, usr) + ', ';
		}

		return a_str += getCityName(city, gStorage.conn.user);
	}

	function build_loc_array(id) {
		let ret = [];

		if (id >= 0) {
			const loc = gStorage.lists.loclist.list.find(l => l.id === id);
			if (!loc)
				return ret;

			if (loc.loct_id === LOCT_ADDR) {
				ret.push(loc.tgt_id);
			} else if (loc.loct_id === LOCT_REG) {
				ret.push(gStorage.lists.reglist.list.find(r => r.id === loc.tgt_id).city_id);
			} else if (loc.loct_id === LOCT_CITY) {
				Array.prototype.push.apply(ret, loc.cities);
			} else if (loc.loct_id === LOCT_ASSO) {
				Array.prototype.push.apply(ret, gStorage.lists.assolist.list.find(a => a.id === loc.tgt_id).cities);
			}
		} else {
			/* Request from city stats */
			ret.push(-id);
		}

		return ret;
	}

	function get_loc_addr(id) {
		/* Request from city stats */
		if (id < 0)
			return '';

		const loc = gStorage.lists.loclist.list.find(l => l.id === id);
		if (!loc)
			return '';

		if (loc.loct_id === LOCT_ADDR) {
			return loc.address;
		} else if (loc.loct_id === LOCT_REG) {
			return gStorage.lists.reglist.list.find(r => r.id === loc.tgt_id).name;
		}

		return '';
	}

	function locationChange(event) {
		gStorage.stats.setLocation(parseInt(event.target.value, 10));
		gStorage.stats.setObsList(null);
	}

	function locationYearChange(event) {
		gStorage.stats.setStatsYear(event.target.value);
		gStorage.stats.setObsList(null);
	}

	function locationList() {
		let prev_loct_id = -1;
		let b = [];

		const locList = gStorage.lists.loclist.list.slice().sort(locListSort);

		/* Find types */
		locList.forEach((l, i) => {
			if (prev_loct_id !== l.loct_id) {
				const lt = locTypes.find(lt => lt.id === l.loct_id);

				b.push({...lt, id: -1000 - lt.id});
				prev_loct_id = l.loct_id;
			}
		});

		/* Add childrens to each type */
		let a = [{id:  0, loct_id: 0, name: t('stats.none')}];
		
		if (gStorage.stats.location >= 0) {
			a = [{id:  0, loct_id: 0, name: t('stats.none')}];
		} else {
			a = [{id:  0, loct_id: 0, name: t('stats.custom_city') + ' '  + statsLocGetCityName(-gStorage.stats.location)}];
		}

		b.forEach((lt, i) => {
			a.push({...lt, children: locList.filter(l => {
				return l.loct_id === -(lt.id + 1000);
			})});
		});

		return a.map((val) => {
			if (val.children) {
   				return (<optgroup value={val.id} key={val.id} label={t(val.plural)}>
						{val.children.map((child) => {
							return (<option value={child.id} key={child.id}>{child.name}</option>);
						})};
					</optgroup>);
			} else {
				return (<option value={val.id} key={val.id}>{val.name}</option>);
			}
		});
	}

	function locAddLeftEnabled() {
		return gStorage.stats.location !== 0 && gStorage.stats.obsList && gStorage.stats.obsList.length !== 0 &&
			(gStorage.stats.rightList.tab !== TAB_LOC || gStorage.stats.rightList.location !== gStorage.stats.location);
	}
	
	function locAddLeft() {
		gStorage.stats.setLeftList({...gStorage.stats.leftList, tab: TAB_LOC, location: gStorage.stats.location, list: gStorage.stats.obsList.slice()});
	}

	function locAddRightEnabled() {
		return gStorage.stats.location !== 0 && gStorage.stats.obsList && gStorage.stats.obsList.length !== 0 &&
			(gStorage.stats.leftList.tab !== TAB_LOC || gStorage.stats.leftList.location !== gStorage.stats.location);
	}
	
	function locAddRight() {
		gStorage.stats.setRightList({...gStorage.stats.rightList, tab: TAB_LOC, location: gStorage.stats.location, list: gStorage.stats.obsList.slice()});
	}

	function locStatsRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('locStatsRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('locStatsRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_LOCATION || gStorage.stats.loc_tab !== TAB_LOC)
			return;

// 		console.log('locStatsRxWs', msg);
		gStorage.stats.setObsList(msg.data.list);
	}

	function locLoadStats() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'location',
			op: 'list',
			data: {
				loc_arr: build_loc_array(gStorage.stats.location),
				addr: get_loc_addr(gStorage.stats.location),
				year: gStorage.stats.statsYear,
			},
		}

		/* console.log('locLoadStats: Tx:', msg); */
		gStorage.conn.ws.send(msg, locStatsRxWs);
	}

	if (gStorage.stats.tab !== TAB_LOCATION || gStorage.stats.loc_tab !== TAB_LOC)
		return null;
	
	if (!gStorage.stats.obsList && gStorage.stats.location  && gStorage.conn.online)
		locLoadStats();
	
	return (
		<>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl>
						<div>
							<Button disabled={!locAddLeftEnabled()} onClick={locAddLeft}>
								L&nbsp;
								<AddCircleOutlineIcon/>
							</Button>

							&nbsp;&nbsp;&nbsp;&nbsp;

							<Select native
								size='small'
								value={gStorage.stats.location}
								onChange={locationChange}
								disabled={!gStorage.conn.online}
							>
								{locationList()}
							</Select>

							&nbsp;&nbsp;&nbsp;&nbsp;

							<Button disabled={!locAddRightEnabled()} onClick={locAddRight}>
								<AddCircleOutlineIcon/>
								&nbsp;R
							</Button>
						</div>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'} sx={{margin: 1}}>
					<StatsFilter 
						time = {{
							year: {
								year: gStorage.stats.statsYear,
								onChange: locationYearChange,
								enabled: gStorage.conn.online && gStorage.stats.location,
								allowNone: true
							}
						}}
					/>
				</Grid>
			</Grid>	
			{gStorage.stats.obsList &&
			<TableContainer component={Paper} elevation={0}>
				<Table size='small'>
					<TableHead>
						<TableRow>
							<TableCell>#</TableCell>
							<TableCell>{t('main.species')}</TableCell>
							<TableCell>{t('main.time')}</TableCell>
							<TableCell>{t('main.location')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						<LocationSrc arr={gStorage.stats.obsList} />
					</TableBody>
				</Table>
			</TableContainer>
			}
		</>	
	);
});

export default StatsLoc;
